// src/components/Cart/CartItem.jsx
import React from 'react';
import { ListItem, Box, Typography, IconButton, TextField } from '@mui/material';
import { Delete } from 'lucide-react';
import { useCart } from '../../context/CartContext';
import { useTranslation } from 'react-i18next';

export const CartItem = ({ item }) => {
  const { removeFromCart, updateQuantity } = useCart();
  const { t } = useTranslation();

  return (
    <ListItem
      sx={{
        flexDirection: 'column',
        alignItems: 'flex-start',
        border: '1px solid #e0e0e0',
        borderRadius: 1,
        mb: 1,
        p: 2
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', mb: 1 }}>
        <Typography variant="subtitle1">{item.name}</Typography>
        <IconButton
          size="small"
          onClick={() => removeFromCart(item.id)}
          color="error"
        >
          <Delete size={18} />
        </IconButton>
      </Box>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        €{item.price} {t('cart.each')}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
        <TextField
          type="number"
          size="small"
          value={item.quantity}
          onChange={(e) => updateQuantity(item.id, parseInt(e.target.value) || 0)}
          inputProps={{ min: 0, style: { width: '60px' } }}
        />
        <Typography variant="body1" sx={{ ml: 'auto' }}>
          €{(item.price * item.quantity).toFixed(2)}
        </Typography>
      </Box>
    </ListItem>
  );
};